module.exports = __webpack_public_path__ + "img/horizontal_6_7_pp23_8017.faccb4d9.png";